export default __webpack_public_path__ + "static/badge_butterfly-56daaa7182a39427bf92544dcaf9231f.png";